<template>
  <nav class="c-navigation-drawer u-color-primary">
    <div class="c-navigation-drawer__top">
      <i
        v-accessibility-focus="close"
        class="o-icon o-icon--close o-typography--action"
      ></i>
    </div>
    <ui-mobile-drawer
      v-if="$window.isMobileView"
      @close="close"
      @showProfiles="showProfiles"
    ></ui-mobile-drawer>
    <ui-desktop-drawer
      v-else
      @close="close"
      @showProfiles="showProfiles"
    ></ui-desktop-drawer>
  </nav>
</template>
<script>
  import UiMobileDrawer from './mobile.vue';
  import UiDesktopDrawer from './desktop.vue';

  export default {
    components: {
      UiMobileDrawer,
      UiDesktopDrawer,
    },
    methods: {
      close() {
        this.$emit('close');
      },
      showProfiles(options) {
        this.$emit('showProfiles', options);
      },
    },
  };
</script>
